(function () {
  var reduz = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var temIO = 'IntersectionObserver' in window;

  /* ---------- Guia de tamanhos (dialog) ---------- */
  document.addEventListener('click', function (e) {
    var abre = e.target.closest('[data-nk-abre]');
    if (abre) {
      var d = document.getElementById(abre.getAttribute('data-nk-abre'));
      if (d && d.showModal) { d.showModal(); }
      return;
    }
    var fecha = e.target.closest('[data-nk-fecha]');
    if (fecha) { fecha.closest('dialog').close(); return; }
    // Clique fora da caixa (no fundo escuro) fecha.
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('nk-guia')) e.target.close();
  });

  /* ---------- Barra fixa de compra (celular) ---------- */
  function iniciarBarra(raiz) {
    var barra = raiz.querySelector('[data-nk-barra]');
    if (!barra || !temIO) return;
    var real = document.querySelector('.add-to-cart-button');
    if (!real) return;
    barra.hidden = false;
    new IntersectionObserver(function (itens) {
      // Só aparece depois que o botão real passou para cima da tela.
      var it = itens[0];
      barra.classList.toggle('is-on', !it.isIntersecting && it.boundingClientRect.top < 0);
    }).observe(real);
    barra.querySelector('[data-nk-barra-btn]').addEventListener('click', function () {
      if (real.disabled) { real.scrollIntoView({ behavior: reduz ? 'auto' : 'smooth', block: 'center' }); return; }
      real.click();
    });
    // Mostra o tamanho escolhido no botão ("Adicionar · M").
    var btnBarra = barra.querySelector('[data-nk-barra-btn]');
    var tamanhoAtual = function () {
      var marcado = document.querySelector('input[data-option-name="Tamanho"]:checked, input[data-option-name="Size"]:checked');
      btnBarra.textContent = marcado ? 'Adicionar · ' + marcado.value : 'Comprar';
    };
    tamanhoAtual();
    document.addEventListener('change', function (e) { if (e.target && e.target.matches && e.target.matches('input[data-option-name]')) setTimeout(tamanhoAtual, 50); });
    // Acompanha o preço da variante escolhida.
    var precoTema = document.querySelector('product-price');
    var precoBarra = barra.querySelector('[data-nk-barra-preco]');
    if (precoTema && precoBarra) {
      var copiar = function () {
        var atual = precoTema.querySelector('.price');
        if (atual) precoBarra.textContent = atual.textContent.trim();
      };
      new MutationObserver(copiar).observe(precoTema, { childList: true, subtree: true, characterData: true });
    }
  }

  /* ---------- Entrada suave + manifesto ---------- */
  var io = null;
  if (!reduz && temIO) {
    document.documentElement.classList.add('nk-js');
    io = new IntersectionObserver(function (itens) {
      itens.forEach(function (i) {
        if (i.isIntersecting) { i.target.classList.add('is-on'); io.unobserve(i.target); }
      });
    }, { rootMargin: '0px 0px -12% 0px' });
  }
  function observar(raiz) {
    if (!io) return;
    raiz.querySelectorAll('.nk-reveal:not(.is-on), [data-nk-linha]:not(.is-on)').forEach(function (el) { io.observe(el); });
  }

  // Ø do manifesto gira conforme a rolagem.
  var gira = [];
  function coletar() { gira = reduz ? [] : Array.prototype.slice.call(document.querySelectorAll('[data-nk-gira]')); }
  var pendente = false;
  // capture: o tema rola dentro de .page-wrapper, não na janela, então o evento não chega no window.
  document.addEventListener('scroll', function () {
    if (pendente || !gira.length) return;
    pendente = true;
    requestAnimationFrame(function () {
      gira.forEach(function (el) {
        var r = el.getBoundingClientRect();
        el.style.transform = 'rotate(' + ((window.innerHeight - r.top) * 0.25).toFixed(1) + 'deg)';
      });
      pendente = false;
    });
  }, { passive: true, capture: true });

  function iniciar() { observar(document); coletar(); iniciarBarra(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
  // Editor do tema recarrega seções isoladas.
  document.addEventListener('shopify:section:load', function (e) { observar(e.target); coletar(); iniciarBarra(e.target); });
})();
